// `Math.log1p` method
// https://tc39.github.io/ecma262/#sec-math.log1p
require('../internals/export')({ target: 'Math', stat: true }, { log1p: require('../internals/math-log1p') });
